import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndexHotelComponent } from './core/components/index-hotel/index-hotel.component';
import { MasterPageComponent } from './core/components/master-page/master-page.component';
import { PageAboutusComponent } from './core/components/page-aboutus/page-aboutus.component';
import { PageContactThreeComponent } from './core/components/page-contact-three/page-contact-three.component';
import { PageHistoryComponent } from './core/components/page-history/page-history.component';
import { SwitcherComponent } from './shared/switcher/switcher.component';
import { PortfolioModernTwoComponent } from './core/components/portfolio-modern-two/portfolio-modern-two.component';
import {UiFormComponent} from "./core/components/ui-form/ui-form.component";

const routes: Routes = [
  {
    path: '',
    component: MasterPageComponent,
    children: [
      { path: '', component: IndexHotelComponent },
      { path: 'index', component: IndexHotelComponent },
      { path: 'hotel', component: PageContactThreeComponent },
      { path: 'hotels', component: PageContactThreeComponent },
      { path: 'lasa', component: PageAboutusComponent },
      { path: 'program', component: PageHistoryComponent },
      { path: '#', component: SwitcherComponent },
      { path: 'tourism', component: PortfolioModernTwoComponent },
      { path: 'form', component: UiFormComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top",
  scrollOffset: [0, 0],
  // Enable scrolling to anchors
  anchorScrolling: "enabled"})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
